export default "/_next/static/assets/fonts/GoodOT-UltraItalic.35186dc8bace1f92da630737472ab83c.woff2";